import { Link } from "@/i18n/navigation";
import clsx from "clsx";
import Image from "next/image";

function pushCtaClickDataLayer(dataLayerPayload, cta_button) {
  if (typeof window === "undefined" || !dataLayerPayload) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...dataLayerPayload,
    cta_button: cta_button ?? "",
  });
}

/* 
  example data:
  {
    "RedirectUrl": "https://www.turna.com/blog/turkiye/istanbul",
    "Title": "İstanbul",
    "DurationInTotalMinutes": 0,
    "DurationInMinutes": 0,
    "DurationInHours": 0,
    "DurationInDays": 0,
    "IconImage": {
      "ImageUrl": "https://res.cloudinary.com/turna/image/upload/q_auto,f_auto/v1736835711/Images/Pictures/MainPage/188x250/Turna_gorseller_188x250px_istanbul.webp",
      "ImageAlt": "İstanbul Blog Sayfası"
    },
    "AnchorTitle": "İstanbul Otobüs Bileti"
  },
*/

export default function PopularLocationCard({
  item = {},
  wrapperClassName = "",
  dataLayerPayload = null,
}) {
  const { RedirectUrl, Title, IconImage, AnchorTitle } = item;

  const handleClick = () => {
    if (dataLayerPayload) {
      pushCtaClickDataLayer(dataLayerPayload, Title);
    }
  };

  return (
    <Link href={RedirectUrl || "#"} title={AnchorTitle} onClick={handleClick}>
      <div
        className={clsx(
          "relative aspect-[230/240] w-full overflow-hidden rounded-lg shadow-sm",
          wrapperClassName,
        )}
      >
        {IconImage?.ImageUrl && (
          <Image
            src={IconImage.ImageUrl}
            alt={IconImage.ImageAlt || Title || "Location"}
            fill
            className="object-cover"
            sizes="230px"
          />
        )}
        <div className="gradient-overlay absolute inset-0" />
        {Title && (
          <div className="absolute bottom-6 left-6 z-10 text-white">
            <p className="text-xl font-normal">{Title}</p>
          </div>
        )}
      </div>
    </Link>
  );
}
